import React, { forwardRef } from 'react';
import styles from './SelectionTooltip.module.scss';

export interface IProps {
    /**
     * Значение по оси y1
     */
    y1?: number;

    /**
     * Значение по оси y2
     */
    y2?: number;

    /**
     * Ширина столбика, чтобы отображать двигающийся задник такой же ширины, что и столбик
     */
    lineWidth: number;
}

/**
 * Элемент для работы с ховером на графиках
 */
const SelectionTooltip = forwardRef<SVGLineElement, IProps>(({
    y2,
    y1,
    lineWidth,
}, ref) => {
    return (
        <line
            x1={0}
            x2={0}
            y1={y1}
            y2={y2}
            stroke="#0000000A"
            className={styles['line']}
            strokeWidth={lineWidth}
            ref={ref}
        />
    );
});

export default SelectionTooltip;
